import enIcon from '../images/language-code-icons/en.png'
import esIcon from '../images/language-code-icons/es.png'
import cutlineIcon from '../images/report-icons/cutline-icon.png';
import { tooltipTypes } from '../components/Global/Tooltip';

// TODO deprecate this constant and make legend a prop of each report
export const legendItems = [
  {
    colorBlockClass: "bad",
    text: "At Risk, Stronger Signals",
    tooltipType: tooltipTypes.atRisk,
  },
  {
    colorBlockClass: "average",
    text: "At Risk, Weaker Signals",
  },
  {
    colorBlockClass: "great",
    text: "Low Risk",
  }
];

export const dyslexiaRiskLegendItems = [
  {
    icon: enIcon,
    text: "English Reading Risk"
  },
  {
    icon: esIcon,
    text: "Spanish Reading Risk"
  },
  ...legendItems,
  {
    icon: cutlineIcon,
    text: "Risk Cutline"
  }
]